module.exports = __webpack_public_path__ + "static/media/catalent.4c17e9ac.png";